const HB_BOUNCING_INDICATOR_VIEW_TYPES = {
  REGULAR: 'REGULAR',
  SMALL: 'SMALL',
  FULL_SCREEN: 'FULL_SCREEN',
};

const HB_BOUNCING_INDICATOR_VIEW_TYPE_CONFIGS = {
  [HB_BOUNCING_INDICATOR_VIEW_TYPES.REGULAR]: {
    className: 'regularRoot',
  },
  [HB_BOUNCING_INDICATOR_VIEW_TYPES.SMALL]: {
    className: 'smallRoot',
  },
  [HB_BOUNCING_INDICATOR_VIEW_TYPES.FULL_SCREEN]: {
    className: 'fullScreenRoot',
  },
};

export {
  HB_BOUNCING_INDICATOR_VIEW_TYPES,
  HB_BOUNCING_INDICATOR_VIEW_TYPE_CONFIGS,
};
